import { FC } from "react";

import { Box, Button, ScrollArea } from "@mantine/core";
import { modals } from "@mantine/modals";
import DOMPurify from "dompurify";

import { Template } from "../../models/Template.ts";

interface TemplatePreviewComponentProps {
  template: Template;
}

const TemplatePreviewComponent: FC<TemplatePreviewComponentProps> = ({ template }) => {
  return (
    <>
      <ScrollArea h={"60%"}>
        <Box
          size={"xl"}
          style={{ pointerEvents: "none" }}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(template.body) }}
        />
      </ScrollArea>{" "}
    </>
  );
};

export const TemplatePreviewModal = (template: Template) => {
  return (
    <Button
      className={"secondary-button"}
      onClick={() => {
        modals.open({
          title: <h2 style={{ fontWeight: "bold" }}>{template.code} preview</h2>,
          size: "xl",
          children: <TemplatePreviewComponent template={template} />
        });
      }}
    >
      Preview
    </Button>
  );
};
